/**
 * @generated SignedSource<<db82024ab5b495292c938234da5569c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ProposalStatus = "ACTIVE" | "CANCELLED" | "DEFEATED" | "EXECUTED" | "EXPIRED" | "OBJECTION_PERIOD" | "PENDING" | "QUEUED" | "UPDATABLE" | "VETOED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type OnChainProposalRowActivityFragment$data = {
  readonly againstVotes: {
    readonly amount: string;
  };
  readonly forVotes: {
    readonly amount: string;
  };
  readonly status: ProposalStatus;
  readonly voteEndsAt: number;
  readonly voteStartsAt: number;
  readonly " $fragmentType": "OnChainProposalRowActivityFragment";
};
export type OnChainProposalRowActivityFragment$key = {
  readonly " $data"?: OnChainProposalRowActivityFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"OnChainProposalRowActivityFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OnChainProposalRowActivityFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voteEndsAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voteStartsAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TokenAmount",
      "kind": "LinkedField",
      "name": "forVotes",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TokenAmount",
      "kind": "LinkedField",
      "name": "againstVotes",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "OnChainProposal",
  "abstractKey": null
};
})();

(node as any).hash = "b70dc505b47dfa452b56008fa74c0dc2";

export default node;
